// extracted by mini-css-extract-plugin
export default {"section":"DeptTab_section__sd58Q","title":"DeptTab_title__dtb4I"};